// extracted by mini-css-extract-plugin
export default {"table":"contract-fees_table__82Vt9"};